<template>
	<div
		:class="classes"
		class="article-cover-image"
		role="img"
		:aria-label="ariaLabel"
		data-test="article-cover-image-element"
		:style="coverImageStyle"
	></div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { SanityAsset } from 'types/sanity';

interface Props {
	coverImage: SanityAsset;
	classes?: string;
}

const props = defineProps<Props>();

const fallbackImage = `${appCloudfrontPath}/images/marketing-site/placeholder.png`;

const coverImageStyle = computed(() => ({
	backgroundImage: `url(${props.coverImage?.url ? props.coverImage.url : fallbackImage})`
}));

const ariaLabel = computed(() => props.coverImage?.altText ?? 'article cover image');
</script>
